import LegalConsentKeyBuilders from './lib/LegalConsentKeyBuilders';
import LegalConsentOptions from './constants/legalConsentOptions';
import getIsLegitimateInterest from './utils/getIsLegitimateInterest';
import getIsImplicityConsent from './utils/getIsImplicityConsent';
import getCommunicationConsentCheckboxes from './utils/getCommunicationConsentCheckboxes';
const buildLegalConsent = ({
  legalConsentOption,
  legalConsentCopy,
  subscriptionDefinitions,
  communicationConsentCheckboxes = []
}) => {
  const isLegitimateInterest = getIsLegitimateInterest(legalConsentOption);
  const isImplicityConsent = getIsImplicityConsent(legalConsentOption);
  const updatedCommunicationConsentCheckboxes = getCommunicationConsentCheckboxes({
    legalConsentCopy,
    subscriptionDefinitions,
    communicationConsentCheckboxes
  });
  if (legalConsentOption === LegalConsentOptions.NONE) {
    return null;
  }
  return LegalConsentKeyBuilders.reduce((acc, keyBuilder) => Object.assign({}, acc, {
    [keyBuilder.key]: keyBuilder.getValue({
      legalConsentOption,
      legalConsentCopy,
      isLegitimateInterest,
      isImplicityConsent,
      communicationConsentCheckboxes: updatedCommunicationConsentCheckboxes
    })
  }), {});
};
export default buildLegalConsent;